import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { Avatar, Box, Typography } from "@mui/material";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";

function Testimonials() {
  const [reviews, setReviews] = useState([]);
  const [expandedReviews, setExpandedReviews] = useState({}); // Track expanded state
  const firestore = getFirestore();

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const querySnapshot = await getDocs(
          collection(firestore, "google_Reviews")
        );
        const reviewsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setReviews(reviewsList);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [firestore]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const toggleExpand = (id) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the expanded state for the specific review
    }));
  };

  return (
    <section className='testimonials-section'>
      <div className='container'>
        <div className='testimonials-content'>
          <div className='testimonials-content__title'>
            <h2>Reviewed by Real People</h2>
            <p>
              Discover the positive impact we've made on our clients by
              reading their testimonials. We like to stay a little old school
              and do business face-to-face. Below is what our clients think of
              us.
            </p>
          </div>
          <div className='client-feedback'>
            <div className='slider-container'>
              <Slider {...settings}>
                {reviews.map((review) => {
                  const isExpanded = expandedReviews[review.id] || false; // Get the expanded state
                  const truncatedContent = review.review.length > 100 ? review.review.substring(0, 120) + '...' : review.review;

                  return (
                    <div key={review.id}>
                      <Box
                        sx={{
                          padding: "20px",
                          textAlign: "center",
                          backgroundColor: "#fff",
                          borderRadius: "15px",
                          border: "2px solid #e2e2e2",
                          width: "calc(100% - 30px)",
                          margin: "10px 15px",
                          transition: "max-height 0.3s ease-in-out", // Smooth transition
                          height: isExpanded ? "none" : "34vh", // Change height based on expanded state
                          overflow: "hidden", // Hide overflow when not expanded
                          "@media (max-width: 600px)": {
                            height: isExpanded ? "none" : "auto", // Set height to 40vh for mobile view
                          }
                        }}
                      >
                        <Avatar
                          src={review.avatar}
                          alt={review.name}
                          sx={{
                            width: 80,
                            height: 80,
                            margin: "0 auto",
                            marginBottom: "15px",
                          }}
                        />
                        <Typography variant='h6' sx={{ fontWeight: 600 }}>
                          {review.name}
                        </Typography>
                        <Typography variant='body2' sx={{ color: "#555", marginBottom: "10px" }}>
                          {isExpanded ? review.review : truncatedContent}
                        </Typography>

                        <Typography sx={{ fontWeight: 600, color: "#f39c12" }}>
                          {`⭐`.repeat(review.rating)}
                        </Typography>
                        {/* Show "Read more" link only if content is long enough */}
                        {review.review.length > 100 && (
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: "#0071ff",
                              cursor: "pointer",
                              marginTop: "5px",
                           float: "right",
                            }}
                            onClick={() => toggleExpand(review.id)} // Toggle on click
                          >
                            {isExpanded ? "Read less" : "Read more"}
                          </Typography>
                        )}

                      </Box>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
